import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./components/homepage/HomePage";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import InterIIT from "./components/interiit/InterIIT";
import ContactUs from "./components/Contact/ContactUs";
import Sports from "./components/sports/Sports";
import Aquatics from "./components/sports/SportsPages/aquatics/src/aquatics/aquatics";
import SAC from "./components/Contact/SAC";
import Council from "./components/Contact/SportsCouncil";
import Webteam from "./components/Contact/webteam";
import BookingPage from "./components/turf-booking/BookingPage";
import AdminPage from "./components/turf-booking/AdminPage";
import "./App.css"; // Import any additional global styles

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/sports/" element={<HomePage />} />
        <Route path="/sports/inter-iit" element={<InterIIT />} />
        <Route path="/sports/contact" element={<ContactUs />} />
        <Route path="/sports/explore" element={<Sports/>} />
        <Route path="/sports/aquatics" element={<Aquatics />} />
        <Route path="/sports/SAC" element={<SAC/>} />
        <Route path="/sports/Council" element={<Council/>} />
        <Route path="/sports/Webteam" element={<Webteam/>} />
        <Route path="/sports/turfbooking" element={<BookingPage/>} />
        <Route path="/sports/admin-turf-booking-raj" element={<AdminPage/>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
